/* eslint-disable import/no-anonymous-default-export */
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {pxToRem} from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION GENERAL SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
  adssection: {
    '& .collapsable.opened': {
      maxHeight: pxToRem(3000)
    },
    '& .sectiongroupv2 > .header': {
      width: '100%'
    }
  }
});
